import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../../../../environments/environment";
import {ReviewPage} from '../../../model/review-page';

@Injectable()
export class ReviewsService {

  constructor(private http: HttpClient) {
  }

  getReviews(pageNum, pageSize, userId?): Observable<ReviewPage> {
    let params;
    if (userId === undefined) {
      params = new HttpParams({
        fromObject: {
          pageNum: pageNum,
          pageSize: pageSize
        }
      });
    } else {
      params = new HttpParams({
        fromObject: {
          pageNum: pageNum,
          pageSize: pageSize,
          userId: userId
        }
      });
    }
    return this.http.get<ReviewPage>(environment.serverUrl + '/reviews/get-reviews-by-page', {params: params});
  }

  getAverageRating() {
    return this.http.get<any>(environment.serverUrl + '/reviews/get-average-rating');
  }

}
